<script>
  import { fly } from 'svelte/transition';
  import { Icon, ChevronDown, User, LockClosed, Logout } from 'svelte-hero-icons';

  import { APIS } from '$lib/utils/consts';
  import { Request } from '$lib/utils/_api';
  import { TiLocalStorage, USER } from '$lib/utils/storage';

  import Avatar from '$lib/assets/images/avatar.svg';

  export let username;

  let toggle = false;
  const userMenu = [{
  //   name: "账号管理",
  //   icon: User,
  //   url: '/account/general'
  // }, {
  //   name: "更改密码",
  //   icon: LockClosed,
  //   url: '/account/password'
  // }, {
    name: "退出登录",
    icon: Logout,
    url: 'javascript:void(0);',
    divide: true,
    action: () => toLogout()
  }];

  async function toLogout() {
    const resp = await Request.post(APIS.LOGOUT);
    // console.log(resp);

    if (resp.status === 200) {
      TiLocalStorage.remove(USER);
      window.location.reload();
    }
  }
</script>

<div class="relative" on:mouseenter={() => toggle = true} on:mouseleave={() => toggle = false}>
  <button class="group inline-flex items-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
    <img class="inline-block h-6 w-6 rounded-full ring-2 ring-white mr-1" src={Avatar} alt="Avatar">
    <span>{username}</span>
    <Icon src={ChevronDown} solid class="h-4 w-4 text-gray-500 group-hover:text-gray-900" />
  </button>

  <div class:hidden={!toggle} in:fly >
    <div class="absolute z-10 right-0 mt-0 transform">
      <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
        <nav class="grid bg-white">
          {#each userMenu as menu}
            <a href={menu.url} class="flex items-center w-36 px-4 py-3 text-base text-gray-500 hover:text-gray-700" on:click={menu.action}>
              <Icon src={menu.icon} class="h-6 w-6 mr-2" />
              {menu.name}
            </a>
          {/each}
        </nav>
      </div>
    </div>
  </div>
</div>
